/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { Modal } from 'antd-mobile'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { formatNumber, showToast, TOAST_TYPE } from '@utils/utils'
import { replaceStringToElement } from '@utils/jsxutils'
import { PRICE_TYPE } from '@constants/index'
import * as _ from 'lodash'
// icon
import { GmoneyIco, HeartIco, ScashIco } from '@shared/Icon/MoneyIcon'
// css
import { ProductTrackItem } from '@store/shopStore'
import { ModalBg, NumInputGroup } from '@styles/base.style'
import { BottomBtnWrap, Button, CloseBtn } from '@styles/button.style'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import { ItemShopModalTit, rowStyle } from './index.style'

interface ProductDetailProps {
  track: ProductTrackItem
  onCloseDetail: () => void
}

const ProductDetail: React.FC<ProductDetailProps> = (props: ProductDetailProps) => {
  const {
    track = {
      id: undefined,
      name: '',
      title: '',
      desc: '',
      price: 0,
      price_type: 0,
      img_full: '',
      iab_google: '',
      missionDefId: undefined as number,
    } as ProductTrackItem,
    onCloseDetail,
  } = props
  const { id: productId, name, price, price_type, iab_google, missionDefId, title } = track

  const [itemCount, setItemCount] = useState(1)
  const [buyAgree, setBuyAgree] = useState(false)
  const [updater, setUpdater] = useState(0)

  const { authStore, shopStore, userStore, globalStore } = useRootStore()
  const { userInfo, authInfo } = authStore
  const { cash, heart, mileage, point } = userInfo

  const isMobileApp = window.navigator.userAgent.indexOf('ADV_1') >= 0

  const onClose = () => {
    onCloseDetail()
  }

  const titleLast = replaceStringToElement(title.replace('+', ''), 'G', <GmoneyIco/>)

  const getPriceImg = () => {
    switch (price_type) {
      case PRICE_TYPE.S_CASH:
        return <ScashIco/>
      case PRICE_TYPE.HEART:
        return <HeartIco/>
      default:
        return null
    }
  }

  const getAssetOwn = () => {
    let priceOwn
    switch (price_type) {
      case PRICE_TYPE.S_CASH:
        priceOwn = Number(cash)
        break
      case PRICE_TYPE.HEART:
        priceOwn = Number(heart)
        break
      case PRICE_TYPE.MILEAGE:
        priceOwn = Number(mileage)
        break
      case PRICE_TYPE.POINT:
        priceOwn = Number(point)
        break
    }
    return priceOwn || 0
  }

  const getPriceTotal = () => {
    return price * itemCount
  }

  const getAssetRemain = () => {
    return getAssetOwn() - getPriceTotal()
  }

  const android = window.android

  const showValidationMessage = () => {
    switch (price_type) {
      case PRICE_TYPE.S_CASH:
        if (android) {
          showToast(TOAST_TYPE.INFO, 'S캐시가 부족합니다.')
        } else {
          globalStore.pushDialogYesNo({
            id: 'sCashNotEnough',
            text: ['S캐시가 부족합니다.', '충전하시겠습니까?'],
            className: 'small-size',
            positivePress: 'S캐시 충전',
            negativePress: '취소',
            callbackPositive: () => {
              onCloseDetail()
              const url = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}/#/auth_login/${authInfo.authKey}/payment`
              globalStore.toMoveWebHomePage(url, 'self')
            },
          })
        }
        break
      case PRICE_TYPE.HEART:
        showToast(TOAST_TYPE.INFO, '하트가 부족합니다.')
        break
      case PRICE_TYPE.MILEAGE:
        showToast(TOAST_TYPE.INFO, '마일리지가 부족합니다.')
        break
      case PRICE_TYPE.POINT:
        showToast(TOAST_TYPE.INFO, '포인트가 부족합니다.')
        break
    }
  }

  const validationItemCount = newCount => {
    if (newCount < 1) {
      return false
    }
    if (getAssetOwn() - price * newCount < 0) {
      showValidationMessage()
      return false
    }

    return true
  }

  const onClickItemCountHandler = (count: number) => {
    let c = 0
    if (itemCount !== undefined || itemCount !== null) {
      c = itemCount
    }
    const newCount = c + count
    if (validationItemCount(newCount)) {
      setItemCount(newCount)
    }
  }

  const onChangeItemCountHandler = (values: NumberFormatValues) => {
    const newCount = values.floatValue
    if (validationItemCount(newCount)) {
      setItemCount(newCount)
    } else {
      setUpdater(updater + 1)
    }
  }

  const gMoneyPurchaseTrackByGoogleTagManager = () => {
    const event = 'g_money_purchase'

    window.dataLayer.push({
      event,
      product: { price }
    })
  }

  const onClickProductItemBuy = async () => {
    const remain = getAssetRemain()
    if (remain < 0) {
      showValidationMessage()
      return
    }
    if (productId && itemCount > 0) {
      if (price_type === PRICE_TYPE.NONE && iab_google) {
        if (isMobileApp) {
          // eslint-disable-next-line dot-notation
          if (android) {
            const payload = {
              productId: iab_google,
              ticketId: '0',
            }
            android.jnRequestGoogleInappBillingPurchase(JSON.stringify(payload))
          }
        }
      } else if (remain >= 0) {
        const ret = await shopStore.buy(productId, name, itemCount, getPriceTotal(), 0)
        if (missionDefId) {
          await userStore.updateMissionCount(track, itemCount)
        }
        await authStore.refreshSimpleUserInfo(true)
        if (ret) {
          onClose()

          const { sort } = track
          if (_.has(sort, 0)
          && price_type === PRICE_TYPE.S_CASH) {
            gMoneyPurchaseTrackByGoogleTagManager()
          }

          // 아이템 구매 후 연출
          // const gmoneyNum = document.getElementById('itemshopGmoney')
          // gmoneyNum.classList.add('active')
          // setTimeout(() => {
          //   if (gmoneyNum.classList.contains('active')) {
          //     gmoneyNum.classList.remove('active')
          //   }
          // }, 1000)

        }
      }
    }
  }

  const onKeyPressItemBuy = (event) => {
    event.preventDefault()
  }

  const priceImg = getPriceImg()
  const price_total = getPriceTotal()

  const visibleDetail = !!productId

  globalStore.updateVisibleModalList(visibleDetail, 'ProductDetail:visibleDetail')

  const resetBuyAgreeState = () => {
    setBuyAgree(false)
  }
  const resetItemCountState = () => {
    setItemCount(1)
  }

  if (!visibleDetail) {
    if (buyAgree) {
      resetBuyAgreeState()
    }
    if (itemCount > 1) {
      resetItemCountState()
    }
  }

  const onClickItemCountDecreaseButton = () => onClickItemCountHandler(-1)
  const onClickItemCountIncreaseButton = () => onClickItemCountHandler(1)

  // G머니 탭에 속한 아이템 ID
  const GmoneyItemId = [28, 29, 30, 31, 32, 33, 62, 63, 64, 65]

  let plus
  if (_.includes(GmoneyItemId, productId)) {
    plus = '+'
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        onClose={onCloseDetail}
        visible={visibleDetail}
        animated={isMobile}
        animationType="slide-up"
        title={
          <Fragment>
            <h1 className="title" css={ItemShopModalTit}>
              {titleLast}
              {plus} {name}
            </h1>
          </Fragment>
        }
        className="short-top pc-close-btn-modal"
      >
        {!isMobile &&
        <Button
          circle
          onClick={onCloseDetail}
          css={CloseBtn}
          className="close-btn pc-close-circle-btn">
          <span className="close-txt ">닫기</span>
        </Button>
        }

        {visibleDetail && (
          <Fragment>
            <div css={rowStyle} className="quantity">
              수량
              <NumInputGroup className="white-input">
                <Button className="left btn" onClick={onClickItemCountDecreaseButton}>
                  &#45;
                </Button>
                <NumberFormat
                  pattern="\d*"
                  maxLength={20}
                  decimalScale={0}
                  allowNegative={false}
                  value={itemCount}
                  thousandSeparator
                  className="input number-format"
                  onValueChange={onChangeItemCountHandler}
                />
                <Button className="right btn" onClick={onClickItemCountIncreaseButton}>
                  &#43;
                </Button>
              </NumInputGroup>
            </div>

            <div css={rowStyle} className="price">
              아이템 가격
              <span className="price">{formatNumber(price_total)} {priceImg}</span>
            </div>

            <p className="point-color--red--modal" style={{ marginTop: 8 }}>
              &#8251; 구매 즉시 사용으로 간주되는 청약철회 제한 상품입니다.
            </p>

            <BottomBtnWrap>
              <Button onClick={onClose} className="bottom-btn negative-btn">
                닫기
              </Button>
              <Button secondary onKeyPress={onKeyPressItemBuy} onClick={onClickProductItemBuy} className="bottom-btn">
                구매
              </Button>
            </BottomBtnWrap>

            <ModalBg onClick={onCloseDetail}/>
          </Fragment>
        )}
      </Modal>
    </Fragment>
  )
}

export default ProductDetail
